module.exports = __webpack_public_path__ + "media/images/idv-badge-4b9a14fed6d3de3f9422f59d08d2afda.svg";